module.exports = __webpack_public_path__ + "8942deaef255da479a38f3094217cb5c.png";